import { useTranslation } from 'react-i18next'
import useAppConfiguration from '@client-hub/shared/react/hooks/useAppConfiguration'
import LegalDocBase from 'components/LegalDocBase'

const PrivacyPolicy = () => {
  const { t } = useTranslation()
  const { privacyPolicyDocLink, isLoading } = useAppConfiguration()
  return (
    <LegalDocBase doc={{ link: privacyPolicyDocLink, loading: isLoading }} title={t('routes.privacyPolicy.heading')} />
  )
}

export default PrivacyPolicy
